import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { LayoutModule } from './views/layout/layout.module';
import { AuthGuard } from './core/guard/auth.guard';
import { AppComponent } from './app.component';
import { ErrorPageComponent } from './views/pages/error-page/error-page.component';
import { HIGHLIGHT_OPTIONS } from 'ngx-highlightjs';
import { SharedModule } from './shared/shared.module';
import { ToastrModule } from 'ngx-toastr';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AlertService } from './services/alert.service';
import { AuthenticationService } from './services/authentication.service';
import { DataService } from './services/data.service';
import { HttpInterceptorService } from './services/interceptor.service';
import { UserSessionService } from './services/usersession.service';
import { NgHttpLoaderModule } from 'ng-http-loader';
import { RoleService } from './services/role.service';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime';

import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { NavigationService } from './services/navigation.service';
import { ExcelService } from './services/excel.service';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { LightboxModule } from 'ngx-lightbox';
// import { UserIdleModule } from 'angular-user-idle';
import { RegisterService } from './services/register.service';
import { JsonDataService } from './services/jsondata.service';
import { GenericValidator } from './views/layout/validators/generic-validator';
import { TimelineModule } from './views/pages/timeline/timeline.module';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TimelineComponent } from './views/pages/timeline/timeline.component';
import { MasterPopupComponent } from './views/pages/master-data/master-popup/master-popup.component';
import { SearchPopupComponent } from './views/pages/epermits/search-popup/search-popup.component';
import { PopupModule } from './views/pages/popup/popup.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { MatSelectFilterModule } from 'mat-select-filter';
import { ApplicantDetailPopupComponent } from './views/pages/applicantdetail-popup/applicantdetail-popup.component';
import { PaymentService } from './services/payment.service';
import { MatFormFieldModule } from '@angular/material/form-field';
import { DateTimeAdapter, OWL_DATE_TIME_FORMATS, OWL_DATE_TIME_LOCALE } from 'ng-pick-datetime';
import { MomentDateTimeAdapter } from 'ng-pick-datetime-moment';
import { VehicleDataService } from './services/vehicle-data.service';
import { VehicleService } from './services/vehicle.service';
import { DistanceService } from './services/distance.service';
import { LoaderService } from './services/loader.service';
import { LoaderModule } from './views/layout/loader/loader.module';
import { DirectivesModule } from './views/layout/directives/directives.module';
import { TransactionhistoryPopupComponent } from './views/pages/epermits/transactionhistory-popup/transactionhistory-popup.component';
import { UpdatepromptModule } from './views/layout/updateprompt/updateprompt.module';
import { VersionService } from './services/version.service';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { EnforcementService } from './services/enforcement.service';
import { MimasDashboardService } from './services/mimas-dashboard.service';

export const MY_CUSTOM_FORMATS = {
  parseInput: 'DD/MM/YYYY',
  fullPickerInput: 'DD/MM/YYYY hh:mm a',
  datePickerInput: 'DD/MM/YYYY',
  timePickerInput: 'hh:mm a',
  monthYearLabel: 'MMM-YYYY',
  dateA11yLabel: 'LL',
  monthYearA11yLabel: 'MMMM-YYYY'
};


export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

@NgModule({
  declarations: [
    AppComponent,
    ErrorPageComponent,
    MasterPopupComponent,
    SearchPopupComponent,
    ApplicantDetailPopupComponent,
    TransactionhistoryPopupComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    SharedModule,
    LayoutModule,
    FormsModule,
    MatSelectModule, 
    MatSelectFilterModule,
    ReactiveFormsModule,
    DirectivesModule,
    NgbDropdownModule,
    MatFormFieldModule,
    HttpClientModule,
    ToastrModule.forRoot({
      timeOut: 5000,
      positionClass: 'toast-top-right',
      preventDuplicates: true,
    }),
    NgHttpLoaderModule.forRoot(),
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient]
      }
    }),
    LightboxModule,
    // UserIdleModule.forRoot({idle: 600, timeout: 5, ping: 30}),
    MatDialogModule,
    TimelineModule,
    PopupModule,
    LoaderModule,
    BrowserAnimationsModule,
    UpdatepromptModule,
    MatButtonToggleModule
    
  ],
  providers: [
    { provide: DateTimeAdapter, useClass: MomentDateTimeAdapter, deps: [OWL_DATE_TIME_LOCALE] },
    { provide: OWL_DATE_TIME_FORMATS, useValue: MY_CUSTOM_FORMATS },
    AuthGuard,
    NavigationService,
    {
      provide: HIGHLIGHT_OPTIONS, // https://www.npmjs.com/package/ngx-highlightjs
      useValue: {
        coreLibraryLoader: () => import('highlight.js/lib/core'),
        languages: {
          xml: () => import('highlight.js/lib/languages/xml'),
          typescript: () => import('highlight.js/lib/languages/typescript'),
          scss: () => import('highlight.js/lib/languages/scss'),
        }
      }
    },
    DataService,
    AuthenticationService,
    AlertService,
    RoleService,
    GenericValidator,
    JsonDataService,
    ExcelService,
    UserSessionService,
    PaymentService,
    RegisterService,
    VehicleDataService,
    VehicleService,
    DataService,
    DistanceService,
    LoaderService,
    VersionService,
    EnforcementService,MimasDashboardService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpInterceptorService,
      multi: true
    },
    { provide: MAT_DIALOG_DATA, useValue: {} },
    { provide: MatDialogRef, useValue: {} }
  ],
  bootstrap: [AppComponent],
  entryComponents: [
  ],
})
export class AppModule { }
